import type { ApiResponse } from '@creator/sdk/creator-sdk';
import { post as postApi } from '@creator/sdk/network/api-service';
import creatorSdk from '@src/services/creator-sdk';
import type { Comment } from '@src/store/contentEntities/model';
import type { LinkMeta } from '@src/types/link-meta';
import { setComment } from './comments';

export interface EditCommentApiRequestPayload {
    tokenName: string;
    userId?: string;
    commentId: string;
    content: string;
    linkMeta?: LinkMeta | null;
}

export const editComment = async (payload: EditCommentApiRequestPayload) => {
    const { commentId } = payload;

    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<Comment>>(
        '/comment/edit',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false
    );

    const comment = { ...data.payload, id: commentId };
    setComment(comment);

    return comment;
};
